import React from 'react';
import { Navigate } from 'react-router-dom';

export default function Signup(): React.JSX.Element {
    return <Navigate to="/register?mode=company" replace />;
}

